function debounce(fn, delay) {
    let timeoutId = null;

    const debounced = (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };

    debounced.cancel = () => {
        clearTimeout(timeoutId);
    };

    return debounced;
}
const autosaveLandingPagePlugin = (store) => {
    const mutacoesIgnoradas = [
        'landingPage/DEFINIR_STATUS_SALVAMENTO',
        'landingPage/DEFINIR_STATUS_ATUALIZACAO',
        'landingPage/DEFINIR_STATUS_PREVIEW',
        'landingPage/DEFINIR_ID_ELEMENTO_SELECIONADO',
        'landingPage/DEFINIR_NOME_EVENTO',
        'landingPage/DEFINIR_DIRTY_STATE',
        'landingPage/ATUALIZAR_METADADOS_PAGINA',
    ];

    const salvarNoBackend = debounce(async () => {
        const estado = store.state.landingPage;
        const eventoId = estado.metadadosPagina.eventoId;

        if (!eventoId) {
            console.warn('Autosave Plugin: eventoId não encontrado. Abortando salvamento.');
            return;
        }

        store.dispatch('landingPage/atualizarLandingPage', eventoId);
    }, 1000);

    const salvarImediato = async () => {
        const estado = store.state.landingPage;
        const eventoId = estado.metadadosPagina.eventoId;

        if (!eventoId) {
            console.warn('Autosave Plugin: eventoId não encontrado. Abortando salvamento imediato.');
            return;
        }

        salvarNoBackend.cancel();

        await store.dispatch('landingPage/atualizarLandingPage', eventoId);
    };

    store._cancelLandingPageAutosave = salvarNoBackend.cancel;
    store._salvarLandingPageImediato = salvarImediato;

    if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', async () => {
            const estado = store.state.landingPage;
            if (estado.isDirty) {
                await salvarImediato();
            }
        });
    }

    store.subscribe((mutation) => {
        if (mutacoesIgnoradas.includes(mutation.type)) {
            return;
        }

        if (mutation.type.startsWith('landingPage/')) {
            store.commit('landingPage/DEFINIR_DIRTY_STATE', true);

            if (mutation.type === 'landingPage/ADICIONAR_CHILDREN_POR_ID') {
                const salvarRapido = debounce(async () => {
                    const estado = store.state.landingPage;
                    const eventoId = estado.metadadosPagina.eventoId;
                    if (eventoId) {
                        store.dispatch('landingPage/atualizarLandingPage', eventoId);
                    }
                }, 300);
                salvarRapido();
            } else {
                salvarNoBackend();
            }
        }
    });
};

export default autosaveLandingPagePlugin;
